var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDrag2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 18,
  viewBox: "0 0 14 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.25 4.5C3.49264 4.5 4.5 3.49264 4.5 2.25C4.5 1.00736 3.49264 0 2.25 0C1.00736 0 0 1.00736 0 2.25C0 3.49264 1.00736 4.5 2.25 4.5Z",
  fill: "#A9B6C4"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.25 11.25C3.49264 11.25 4.5 10.2426 4.5 9C4.5 7.75736 3.49264 6.75 2.25 6.75C1.00736 6.75 0 7.75736 0 9C0 10.2426 1.00736 11.25 2.25 11.25Z",
  fill: "#A9B6C4"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.25 18C3.49264 18 4.5 16.9926 4.5 15.75C4.5 14.5074 3.49264 13.5 2.25 13.5C1.00736 13.5 0 14.5074 0 15.75C0 16.9926 1.00736 18 2.25 18Z",
  fill: "#A9B6C4"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.25 4.5C12.4926 4.5 13.5 3.49264 13.5 2.25C13.5 1.00736 12.4926 0 11.25 0C10.0074 0 9 1.00736 9 2.25C9 3.49264 10.0074 4.5 11.25 4.5Z",
  fill: "#A9B6C4"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.25 11.25C12.4926 11.25 13.5 10.2426 13.5 9C13.5 7.75736 12.4926 6.75 11.25 6.75C10.0074 6.75 9 7.75736 9 9C9 10.2426 10.0074 11.25 11.25 11.25Z",
  fill: "#A9B6C4"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.25 18C12.4926 18 13.5 16.9926 13.5 15.75C13.5 14.5074 12.4926 13.5 11.25 13.5C10.0074 13.5 9 14.5074 9 15.75C9 16.9926 10.0074 18 11.25 18Z",
  fill: "#A9B6C4"
})));
export { SvgDrag2 as ReactComponent };
export default __webpack_public_path__ + "static/media/drag2.dbe12150.svg";